import { ICollectionMapper } from '../Firestore/ICollectionMapper'
import { IQuickbooksSetting, QuickbooksSetting } from './QuickbooksSetting'

export class QuickbooksSettingMapper implements ICollectionMapper<QuickbooksSetting> {
  map(data: IQuickbooksSetting): QuickbooksSetting {
    const quickbooksSetting = new QuickbooksSetting(data.restaurantCompanyId)
    quickbooksSetting.id = data.id
    quickbooksSetting.categorySettings = data.categorySettings
    quickbooksSetting.vendorSettings = data.vendorSettings

    return quickbooksSetting
  }

  serialize(object: QuickbooksSetting): IQuickbooksSetting {
    return JSON.parse(JSON.stringify(object))
  }
}
